import React from "react";
import CategoryCard from "../CategoryCard/CategoryCard";
import "./MenuCategories.css";

const MenuCategories = ({ onCategorySelect, title, categories }) => {
  const handleCategoryClick = (categoryId) => {
    console.log(`Navigating to category: ${categoryId}`);
    onCategorySelect?.(categoryId);
  };

  return (
    <section className="menu-categories">
      <div className="container">
        <h2 className="menu-categories-title">{title}</h2>
        <div className="categories-grid">
          {categories.map((category, index) => (
            <div
              key={category.id}
              style={{ "--animation-delay": `${index * 0.1}s` }}
            >
              <CategoryCard
                icon={category.icon}
                title={category.title}
                description={category.description}
                onClick={() => handleCategoryClick(category.id)}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuCategories;
